var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "do-mgt"
  }, [_c('div', {
    staticClass: "do-mgt__version"
  }, [_c('span', [_vm._v(" Environment: ")]), _c('el-select', {
    staticClass: "do-mgt__service-options",
    attrs: {
      "placeholder": "Select environment",
      "disabled": _vm.loading.repoBranches || _vm.loading.deploy || _vm.loading.canaryActivities
    },
    model: {
      value: _vm.selectedCanary,
      callback: function ($$v) {
        _vm.selectedCanary = $$v;
      },
      expression: "selectedCanary"
    }
  }, _vm._l(_vm.canaryNames, function (canary, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": canary.name,
        "value": canary.value
      }
    });
  }), 1)], 1), _c('div', {
    staticClass: "do-mgt__content",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading.repoBranches,
      expression: "loading.repoBranches"
    }],
    staticClass: "do-mgt__services"
  }, [_vm._l(_vm.serviceOptions, function (service, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "do-mgt__services--branches"
    }, [_c('span', [_vm._v(" " + _vm._s(service.name) + ": ")]), _c('el-select', {
      staticClass: "do-mgt__service-options",
      attrs: {
        "filterable": "",
        "placeholder": "Select branch",
        "disabled": _vm.loading.deploy,
        "loading": _vm.loading.repoBranches || _vm.loading.deploy,
        "loading-text": "Loading..."
      },
      model: {
        value: _vm.selectedBranches[index].value,
        callback: function ($$v) {
          _vm.$set(_vm.selectedBranches[index], "value", $$v);
        },
        expression: "selectedBranches[index].value"
      }
    }, _vm._l(_vm.branches(service.name), function (branch, index) {
      return _c('el-option', {
        key: index,
        attrs: {
          "label": branch,
          "value": branch
        }
      });
    }), 1)], 1), _c('div', {
      staticClass: "do-mgt__services--links"
    }, [_c('a', {
      attrs: {
        "href": `https://${_vm.selectedCanary}-${service.host}/gitver`,
        "target": "_blank"
      }
    }, [_vm._v(" Live commit")]), _vm._l(_vm.links(service.name), function (item, index) {
      return _c('a', {
        key: `${index}${item.name}`,
        attrs: {
          "href": item.link,
          "target": "_blank"
        }
      }, [_vm._v(" " + _vm._s(item.name) + " ")]);
    })], 2)]);
  }), _c('div', {
    staticClass: "do-mgt__deploy-btn"
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading.deploy,
      expression: "loading.deploy"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.deploy
    }
  }, [_vm._v(" Deploy ")])], 1)], 2), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading.canaryActivities,
      expression: "loading.canaryActivities"
    }],
    staticClass: "do-mgt__activities"
  }, [_c('div', [_c('el-row', {}, [_c('el-col', {
    staticStyle: {
      "font-weight": "bold"
    }
  })], 1)], 1), _c('el-row', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('el-col', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v(" Start Time ")]), _c('el-col', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v(" User ")]), _c('el-col', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center"
    }
  }, [_vm._v(" anima-api ")]), _c('el-col', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center"
    }
  }, [_vm._v(" anima-codegen ")]), _c('el-col', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center"
    }
  }, [_vm._v(" anima-web ")])], 1), _vm._l(_vm.canaryActivities, function (activity) {
    var _activity$context$bra, _activity$context$com, _activity$context$dep, _activity$context$dur, _activity$context$bra2, _activity$context$com2, _activity$context$dep2, _activity$context$dur2, _activity$context$bra3, _activity$context$com3, _activity$context$dep3, _activity$context$dur3;
    return _c('el-row', {
      key: activity.id
    }, [_c('el-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 12
      }
    }, [_vm._v(" " + _vm._s(activity.date) + " ")]), _c('el-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 12
      }
    }, [_vm._v(" " + _vm._s(activity.user.name) + " ")]), _c('el-col', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(" " + _vm._s((_activity$context$bra = activity.context["branches"]) === null || _activity$context$bra === void 0 ? void 0 : _activity$context$bra["anima-api"]) + ":" + _vm._s(activity === null || activity === void 0 ? void 0 : (_activity$context$com = activity.context["commit_shas"]) === null || _activity$context$com === void 0 ? void 0 : _activity$context$com["anima-api"].slice(-7)) + " "), _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s((_activity$context$dep = activity.context["deployments_status"]) === null || _activity$context$dep === void 0 ? void 0 : _activity$context$dep["anima-api"]) + "(" + _vm._s(_vm.formatDuration((_activity$context$dur = activity.context["durations"]) === null || _activity$context$dur === void 0 ? void 0 : _activity$context$dur["anima-api"])) + ")")])]), _c('el-col', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(" " + _vm._s((_activity$context$bra2 = activity.context["branches"]) === null || _activity$context$bra2 === void 0 ? void 0 : _activity$context$bra2["anima-codegen"]) + ":" + _vm._s(activity === null || activity === void 0 ? void 0 : (_activity$context$com2 = activity.context["commit_shas"]) === null || _activity$context$com2 === void 0 ? void 0 : _activity$context$com2["anima-codegen"].slice(-7)) + " "), _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s((_activity$context$dep2 = activity.context["deployments_status"]) === null || _activity$context$dep2 === void 0 ? void 0 : _activity$context$dep2["anima-codegen"]) + "(" + _vm._s(_vm.formatDuration((_activity$context$dur2 = activity.context["durations"]) === null || _activity$context$dur2 === void 0 ? void 0 : _activity$context$dur2["anima-codegen"])) + ")")])]), _c('el-col', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(" " + _vm._s((_activity$context$bra3 = activity.context["branches"]) === null || _activity$context$bra3 === void 0 ? void 0 : _activity$context$bra3["anima-web"]) + ":" + _vm._s(activity === null || activity === void 0 ? void 0 : (_activity$context$com3 = activity.context["commit_shas"]) === null || _activity$context$com3 === void 0 ? void 0 : _activity$context$com3["anima-web"].slice(-7)) + " "), _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s((_activity$context$dep3 = activity.context["deployments_status"]) === null || _activity$context$dep3 === void 0 ? void 0 : _activity$context$dep3["anima-web"]) + " (" + _vm._s(_vm.formatDuration((_activity$context$dur3 = activity.context["durations"]) === null || _activity$context$dur3 === void 0 ? void 0 : _activity$context$dur3["anima-web"])) + ")")])])], 1);
  })], 2)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }